<template>
  <div class="mid_search_but_wrap" style="display: block" data-note="desktop">
    <div class="seasidetms_header_search_form">
      <span
        class="seasidetms_header_search_form_close seasidetms_theme_icon_cancel"
      ></span>
      <div class="search_bar_wrap searchbar" v-click-outside="hide">
        <form>
          <p class="search_field">
            <input
              id="search"
              autocomplete="off"
              name="s"
              @input="update"
              @focus="show"
              :placeholder="$t('searchProduct')"
              type="search"
              v-model="query"
            />
          </p>
          <p class="search_button">
            <span class="seasidetms-icon-search search_button-icon"></span>
          </p>
        </form>
        <div class="searchbar__box" v-show="isActive && items.length">
          <div class="searchbar__wrapper">
            <div class="searchbar__categories">
              <div class="h3 searchbar__title">В категоріях</div>
              <ul
                :key="category.slug"
                class="searchbar__categories-list"
                v-for="category in categories"
              >
                <li class="searchbar__categories-list-item">
                  <router-link
                    class="searchbar__categories-link"
                    :to="categoryRouteTo(category)"
                    @click.native="onRouteClick"
                  >
                    {{ getProductName(category) }}
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="searchbar__products">
              <div class="h3 searchbar__title">Товари</div>
              <ul class="searchbar__products-list">
                <li
                  class="searchbar__autocomplete-item"
                  v-for="product in items"
                  :key="product._id"
                >
                  <router-link
                    class="searchbar__autocomplete-item-image"
                    :to="routeTo(product)"
                    @click.native="onRouteClick"
                  >
                    <img
                      :src="getProductImgSrc(product)"
                      :alt="getProductName(product)"
                    />
                  </router-link>
                  <router-link
                    class="searchbar__autocomplete-link"
                    :to="routeTo(product)"
                    @click.native="onRouteClick"
                  >
                    <span class="searchbar__autocomplete-name">
                      {{ getProductName(product) }}
                    </span>
                  </router-link>
                  <div class="searchbar__autocomplete-item-price">
                    <div class="searchbar__autocomplete-item-old_price">
                      {{ $h.formatPrice(product.price) }} грн
                    </div>
                    <div class="searchbar__autocomplete-item-new_price">
                      {{ $h.formatPrice(product.newPrice) }} грн
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="searchbar__footer">
            <router-link
              :to="`/search?q=${$h.trimStr(query)}`"
              @click.native="onFullRouteClick"
            >
              Показати всі товари ({{ items.length }})
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { setTimeout, clearTimeout } from 'timers'

export default {
  name: 'SearchBarFly',
  data() {
    return {
      query: '',
      oldQuery: '',
      items: [],
      timer: null,
      isActive: false,
      minChars: 3,
      updatedTime: 300,
      lang: '',
      catObject: {},
      categories: [],
    }
  },
  computed: {
    queryStr() {
      return this.query.trim()
    },
  },
  methods: {
    ...mapActions(['fetchFlySearch']),
    renderItems(response) {
      if (response.length) {
        this.items = response
        this.isActive = true
        this.categories = this.getCategories(response)
      }
    },
    getCategories(products) {
      const cats = new Set([])

      products.forEach(({ childCategory, parentCategory }) => {
        if (parentCategory !== '') {
          cats.add(parentCategory)
        }

        if (Array.isArray(childCategory)) {
          childCategory.forEach((item) => {
            if (typeof item === 'string' && !/,/g.test(item) && item !== '') {
              cats.add(item)
            }
          })
        }
      })
      const catsList = [...cats]
        .map((cat) => {
          if (!this.catObject[cat]) {
            return
          }

          return this.catObject[cat]
        })
        .filter((item) => item)

      return catsList
    },
    getProductImgSrc(product) {
      return Array.isArray(product.img) && this.product.img.length
        ? `/img${product.img[0]}`
        : product.img
        ? `/img${product.img}`
        : '/img/uploads/error.png'
    },
    onRouteClick() {
      this.hide()
      this.reset()
    },
    onFullRouteClick() {
      this.hide()
      this.reset()

      if (this.$route && this.$route.name === 'SearchPage') {
        window.location.reload()
      }
    },
    getProductName(product) {
      return this.lang === 'ru' ? product.name_ru : product.name_ua
    },
    routeTo(product) {
      return this.lang
        ? `/${this.lang}/product/${this.categoryPath(product)}/${product.slug}`
        : `/product/${this.categoryPath(product)}/${product.slug}`
    },
    categoryRouteTo(product) {
      return this.lang
        ? `/${this.lang}/product-category/${product.slug}`
        : `/product-category/${product.slug}`
    },
    categoryPath(product) {
      const cc = `${product.childCategory}`
      let refPath = `${product.parentCategory}/${cc.replace(',', '/')}`
      let path = ''
      let chain = refPath.split('/')
      let _c = this.$store.state.categories
      chain.forEach((p) => {
        if (!_c) return
        let c = _c.find((c) => c.id === p)
        if (c) {
          _c = c.children || null
          if (path !== '') path += '/'
          path += c.slug
        }
      })
      return path
    },
    fetch() {
      this.fetchFlySearch(this.queryStr).then(this.renderItems)
    },
    update() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (!this.query) {
        this.reset()
      }
      if (this.queryStr.length < this.minChars) {
        this.hide()
      } else {
        if (this.oldQuery !== this.query) {
          this.timer = setTimeout(this.fetch, this.updatedTime)
        } else {
          this.isActive = true
        }
      }
    },
    reset() {
      this.items = []
      this.query = ''
    },
    hide() {
      this.isActive = false
      this.oldQuery = this.query
    },
    show() {
      if (this.queryStr.length >= this.minChars) {
        this.isActive = true
      }
    },
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
    this.catObject = Object.fromEntries(
      this.$store.state.categories.map(({ id, name_ru, name_ua, slug }) => [
        id,
        {
          name_ru,
          name_ua,
          slug,
        },
      ])
    )
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
.searchbar__box {
  padding: 15px;
  border-radius: 20px;
  border: 2px solid #ff4300;
  background: #fff;
  position: absolute;
  z-index: 1000;
  width: 100%;
  top: 100%;
  left: 0;
}
.searchbar__wrapper {
  display: flex;
  flex-wrap: nowrap;
}
.searchbar__categories {
  width: 20%;
  padding-right: 10px;
}
.searchbar__products {
  width: 80%;
}
.searchbar__title {
  font-size: 14px;
  font-weight: 700;
}
.searchbar__products-list,
.searchbar__categories-list {
  list-style: none;
  overflow: auto;
  padding: 0;
  margin: 0;
  max-height: 340px;
}
.searchbar__autocomplete-item {
  list-style: none;
  margin: 0 0 15px 0;
  padding: 0;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.searchbar__categories-list-item {
  margin: 0;
  padding: 0;
}
.searchbar__autocomplete-item:before,
.searchbar__categories-list-item:before {
  display: none;
}
.searchbar__autocomplete-item-image {
  display: flex;
  width: 60px;
  height: 60px;
  overflow: hidden;
  margin-right: 10px;
  flex-shrink: 0;
}
.searchbar__autocomplete-item-image img {
  width: 100%;
  object-fit: cover;
}
.searchbar__autocomplete-link {
  font-size: 16px;
  flex-grow: 1;
  line-height: 1.2;
}
.searchbar__autocomplete-item-price {
  font-size: 15px;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
}
.searchbar__autocomplete-item-price div {
  text-align: right;
  line-height: 1;
  white-space: nowrap;
}
.searchbar__autocomplete-item-old_price {
  font-size: 12px;
  color: #555;
  text-decoration: line-through;
}
.searchbar__autocomplete-item-new_price {
  font-weight: 700;
  margin-top: 5px;
}
.searchbar__footer {
  padding: 25px 0 5px;
  text-align: center;
}
</style>
